export const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};
export const isIPad = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /ipad/.test(userAgent);
};
export const isInStandaloneMode = () => window.matchMedia('(display-mode: standalone)').matches;

export const isSafari = () => {
    const ua = window.navigator.userAgent;
    const webkit = !!ua.match(/WebKit/i);
    return isIos() && webkit && !ua.match(/CriOS/i);
};
